import scrollIntoView from 'smooth-scroll-into-view-if-needed';

export class WTCitySelector extends HTMLDivElement
{
    /**
     *
     */
    connectedCallback ()
    {
        this.block = this.querySelector('div:first-child')

        // Transformer le titre en élément cliquable
        this.block.setAttribute(
            'style',
            'display:block; cursor:pointer; color: #0a3d62 !important; text-decoration: underline;'
        )

        const select = document.querySelector('select[name="COMBODATE"]')
        const options = Array.from(select.options)

        this.addEventListener('click', (e) => {
            e.preventDefault()

            const city         = this.block.getAttribute('data-city')
            const url          = new URL(window.location.href)

            // Chercher l'option qui correspond au choix de l'utilisateur
            const optionToSelect = options.find(item => {
                if(item.value.includes(city)) {
                    return true;
                }
            })

            // Sélectionne l'option dans le select
            optionToSelect.selected = true;
            window.changeComboDate()

            // Smooth scroll
            const scrollIntoViewSmoothly =
                'scrollBehavior' in document.documentElement.style
                    ? scrollIntoView
                    : smoothScrollIntoView

            // Scroll jusqu'à l'élément cible
            scrollIntoViewSmoothly(document.querySelector('a[name="inscription"]'), {
                block: 'start',
                behavior: 'smooth',
                // scrollMode: 'if-needed',
            })
        })
    }
}
